import React, { useState } from "react";
import { toast } from "sonner";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

const empty = { name: "", email: "", phone: "", message: "" };

export const EnquiryForm = ({ type = "contact", submitLabel = "Send message", defaultMessage = "" }) => {
  const [form, setForm] = useState({ ...empty, message: defaultMessage });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in your name, email and message.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/submissions", { type, ...form });
      toast.success("Thanks! We've received your message and will be in touch soon.");
      setForm({ ...empty, message: defaultMessage });
    } catch (err) {
      toast.error("Something went wrong. Please try again or email us directly.");
    } finally {
      setLoading(false);
    }
  };

  const field = "rounded-none border-navy/20 bg-white h-12 focus-visible:ring-2 focus-visible:ring-gold focus-visible:border-gold";

  return (
    <form onSubmit={submit} className="space-y-5" data-testid={`enquiry-form-${type}`}>
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <label className="text-sm font-medium text-navy mb-2 block">Name *</label>
          <Input data-testid="form-name" value={form.name} onChange={set("name")} placeholder="Your name" className={field} />
        </div>
        <div>
          <label className="text-sm font-medium text-navy mb-2 block">Email *</label>
          <Input data-testid="form-email" type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" className={field} />
        </div>
      </div>
      <div>
        <label className="text-sm font-medium text-navy mb-2 block">Phone</label>
        <Input data-testid="form-phone" value={form.phone} onChange={set("phone")} placeholder="Optional" className={field} />
      </div>
      <div>
        <label className="text-sm font-medium text-navy mb-2 block">Message *</label>
        <Textarea data-testid="form-message" value={form.message} onChange={set("message")} rows={5} placeholder="How can we help?" className="rounded-none border-navy/20 bg-white focus-visible:ring-2 focus-visible:ring-gold focus-visible:border-gold" />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid="form-submit"
        className="group inline-flex items-center gap-2 bg-navy text-white font-semibold px-8 py-4 rounded-sm transition-colors hover:bg-gold hover:text-navy disabled:opacity-60"
      >
        {loading ? "Sending…" : submitLabel}
        <PaperPlaneTilt size={18} weight="fill" className="transition-transform group-hover:translate-x-1" />
      </button>
    </form>
  );
};
